"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5943],{

/***/ 31993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CheckboxField; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@reach/auto-id/dist/reach-auto-id.esm.js
var reach_auto_id_esm = __webpack_require__(765);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(70714);
// EXTERNAL MODULE: ./node_modules/@reach/utils/context/dist/reach-utils-context.esm.js
var reach_utils_context_esm = __webpack_require__(45558);
// EXTERNAL MODULE: ./node_modules/@reach/utils/dev-utils/dist/reach-utils-dev-utils.esm.js
var reach_utils_dev_utils_esm = __webpack_require__(40884);
// EXTERNAL MODULE: ./node_modules/@reach/utils/compose-refs/dist/reach-utils-compose-refs.esm.js
var reach_utils_compose_refs_esm = __webpack_require__(61331);
// EXTERNAL MODULE: ./node_modules/@reach/utils/compose-event-handlers/dist/reach-utils-compose-event-handlers.esm.js
var reach_utils_compose_event_handlers_esm = __webpack_require__(24683);
// EXTERNAL MODULE: ./node_modules/@reach/utils/use-isomorphic-layout-effect/dist/reach-utils-use-isomorphic-layout-effect.esm.js
var reach_utils_use_isomorphic_layout_effect_esm = __webpack_require__(96637);
// EXTERNAL MODULE: ./node_modules/@xstate/fsm/es/index.js
var es = __webpack_require__(30537);
// EXTERNAL MODULE: ./node_modules/@reach/machine/dist/reach-machine.esm.js + 1 modules
var reach_machine_esm = __webpack_require__(81207);
;// CONCATENATED MODULE: ./node_modules/@reach/checkbox/dist/reach-checkbox.esm.js











function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["as", "checked", "defaultChecked", "disabled", "onChange"];

var _commonEvents;
// Used for development only, not recommended for production code!
var DEBUG = false; ////////////////////////////////////////////////////////////////////////////////
// States

var MixedCheckboxStates; ////////////////////////////////////////////////////////////////////////////////
// Events

(function (MixedCheckboxStates) {
  MixedCheckboxStates["Checked"] = "checked";
  MixedCheckboxStates["Mixed"] = "mixed";
  MixedCheckboxStates["Unchecked"] = "unchecked";
})(MixedCheckboxStates || (MixedCheckboxStates = {}));

var MixedCheckboxEvents; ////////////////////////////////////////////////////////////////////////////////
// Actions & Conditions

/**
 * Toggle events will only update state if the checkbox component is
 * uncontrolled and not disabled.
 *
 * @param context
 */

(function (MixedCheckboxEvents) {
  MixedCheckboxEvents["GetDerivedData"] = "GET_DERIVED_DATA";
  MixedCheckboxEvents["Mount"] = "MOUNT";
  MixedCheckboxEvents["Set"] = "SET";
  MixedCheckboxEvents["Toggle"] = "TOGGLE";
  MixedCheckboxEvents["Unmount"] = "UNMOUNT";
})(MixedCheckboxEvents || (MixedCheckboxEvents = {}));

function checkToggleAllowed(data) {
  return !!(data && !data.isControlled && !data.disabled);
}
/**
 * Set events will update state if the checkbox component is controlled and
 * the state target state matches the state passed in the event.
 *
 * @param state
 */


function getCheckSetCondition(state) {
  return function (data, event) {
    return data && data.isControlled && event.state === state;
  };
}
/**
 * Assign refs to the machine's context data
 */


var assignRefs = /*#__PURE__*/(0,es/* assign */.f0)(function (data, event) {
  return _extends({}, data, {
    refs: event.refs
  });
}); ////////////////////////////////////////////////////////////////////////////////
// State Machine

var commonEvents = (_commonEvents = {}, _commonEvents[MixedCheckboxEvents.Mount] = {
  actions: assignRefs
}, _commonEvents[MixedCheckboxEvents.GetDerivedData] = {
  actions: [assignRefs, /*#__PURE__*/(0,es/* assign */.f0)(function (data, event) {
    return _extends({}, data, event.data);
  })]
}, _commonEvents[MixedCheckboxEvents.Set] = [{
  target: MixedCheckboxStates.Checked,
  cond: /*#__PURE__*/getCheckSetCondition(MixedCheckboxStates.Checked)
}, {
  target: MixedCheckboxStates.Unchecked,
  cond: /*#__PURE__*/getCheckSetCondition(MixedCheckboxStates.Unchecked)
}, {
  target: MixedCheckboxStates.Mixed,
  cond: /*#__PURE__*/getCheckSetCondition(MixedCheckboxStates.Mixed)
}], _commonEvents);
/**
 * Initializer for our state machine.
 *
 * @param initial
 * @param props
 */

var createMachineDefinition = function createMachineDefinition(initial, props) {
  var _extends2, _extends3, _extends4, _states;

  return {
    id: "mixed-checkbox",
    initial: initial,
    context: {
      disabled: props.disabled,
      isControlled: props.isControlled,
      refs: {
        input: null
      }
    },
    states: (_states = {}, _states[MixedCheckboxStates.Unchecked] = {
      entry: assignRefs,
      on: _extends((_extends2 = {}, _extends2[MixedCheckboxEvents.Toggle] = {
        target: MixedCheckboxStates.Checked,
        cond: checkToggleAllowed
      }, _extends2), commonEvents)
    }, _states[MixedCheckboxStates.Checked] = {
      entry: assignRefs,
      on: _extends((_extends3 = {}, _extends3[MixedCheckboxEvents.Toggle] = {
        target: MixedCheckboxStates.Unchecked,
        cond: checkToggleAllowed
      }, _extends3), commonEvents)
    }, _states[MixedCheckboxStates.Mixed] = {
      entry: assignRefs,
      on: _extends((_extends4 = {}, _extends4[MixedCheckboxEvents.Toggle] = {
        target: MixedCheckboxStates.Checked,
        cond: checkToggleAllowed
      }, _extends4), commonEvents)
    }, _states)
  };
}; ////////////////////////////////////////////////////////////////////////////////

/**
 * MixedCheckbox
 *
 * Tri-state checkbox that accepts `checked` values of `true`, `false` or
 * `"mixed"`.
 *
 * @see Docs https://reach.tech/checkbox#mixedcheckbox-1
 */


var MixedCheckbox = /*#__PURE__*/(0,react.forwardRef)(function MixedCheckbox(_ref, forwardedRef) {
  var _ref$as = _ref.as,
      Comp = _ref$as === void 0 ? "input" : _ref$as,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var ownRef = (0,react.useRef)(null);
  var ref = (0,reach_utils_compose_refs_esm/* useComposedRefs */.e)(forwardedRef, ownRef);

  var _useMixedCheckbox = useMixedCheckbox(ownRef, {
    onChange: onChange,
    checked: checked,
    defaultChecked: defaultChecked,
    disabled: disabled
  }, "MixedCheckbox"),
      inputProps = _useMixedCheckbox[0];

  useControlledSwitchWarning(checked, "checked", "MixedCheckbox");
  return /*#__PURE__*/(0,react.createElement)(Comp, _extends({}, props, inputProps, {
    "data-reach-mixed-checkbox": "",
    ref: ref
  }));
});

if (false) {} ////////////////////////////////////////////////////////////////////////////////


/**
 * useMixedCheckbox
 *
 * React hook to create a tri-state checkbox that accepts `checked` values of
 * `true`, `false` or `"mixed"`.
 *
 * @see Docs https://reach.tech/checkbox#usemixedcheckbox
 *
 * @param ref
 * @param args
 */
function useMixedCheckbox(ref, args, functionOrComponentName) {
  if (functionOrComponentName === void 0) {
    functionOrComponentName = "useMixedCheckbox";
  }

  var _ref2 = args || {},
      controlledChecked = _ref2.checked,
      defaultChecked = _ref2.defaultChecked,
      disabled = _ref2.disabled,
      onChange = _ref2.onChange,
      onClick = _ref2.onClick;

  var isControlled = controlledChecked != null;
  var machine = (0,reach_machine_esm/* useCreateMachine */.kv)(createMachineDefinition(checkedPropToStateValue(isControlled ? controlledChecked : defaultChecked), {
    disabled: !!disabled,
    isControlled: isControlled
  }));

  var _useMachine = (0,reach_machine_esm/* useMachine */.eO)(machine, {
    input: ref
  }, DEBUG),
      current = _useMachine[0],
      send = _useMachine[1];

  var props = {
    "aria-checked": stateValueToAriaChecked(current.value),
    checked: stateValueToChecked(current.value),
    disabled: !!disabled,
    onChange: (0,reach_utils_compose_event_handlers_esm/* composeEventHandlers */.M)(onChange, handleChange),
    onClick: (0,reach_utils_compose_event_handlers_esm/* composeEventHandlers */.M)(onClick, handleClick),
    type: "checkbox"
  };
  var contextData = {
    checked: stateValueToAriaChecked(current.value)
  };

  function handleChange() {
    /*
     * If the component is not controlled by the app, we will send the toggle
     * event when the input change handler is called and let our state machine
     * dictate the next state. Othewise we'll call onChange directly and react
     * to any resulting state changes as a side effect.
     */
    if (!isControlled) {
      send(MixedCheckboxEvents.Toggle);
    }
  }

  function handleClick() {
    /*
     * A controlled checkbox will have a checked="mixed" prop, but the
     * underlying input element will receive checked="false" and
     * aria-checked="mixed". A user click will change the underlying
     * element's indeterminate property back to false even if the state
     * doesn't change. This does not trigger a re-render, so our check won't
     * work in a normal effect. We'll check again on every user click and
     * update the node imperatively if the state doesn't change.
     */
    syncDomNodeWithState();
  }

  function syncDomNodeWithState() {
    if (ref.current) {
      ref.current.indeterminate = current.value === MixedCheckboxStates.Mixed;
    }
  }

  useRefDevWarning(ref, "A ref was not assigned to an input element in " + functionOrComponentName + ".");
  (0,react.useEffect)(function () {
    if (isControlled) {
      send({
        type: MixedCheckboxEvents.Set,
        state: checkedPropToStateValue(controlledChecked)
      });
    }
  }, [isControlled, controlledChecked, send]); // Prevent flashing before mixed marker is displayed and check on every render

  (0,reach_utils_use_isomorphic_layout_effect_esm/* useIsomorphicLayoutEffect */.L)(syncDomNodeWithState);
  (0,react.useEffect)(function () {
    send({
      type: MixedCheckboxEvents.GetDerivedData,
      data: {
        disabled: disabled,
        isControlled: isControlled
      }
    });
  }, [disabled, isControlled, send]);
  return [props, contextData];
} ////////////////////////////////////////////////////////////////////////////////

/*
 * We want the API to be similar to the native DOM input API, so we opt for a
 * checked prop with a value of `true`, `false` or `"mixed"`.
 */


function checkedPropToStateValue(checked) {
  return checked === true ? MixedCheckboxStates.Checked : checked === "mixed" ? MixedCheckboxStates.Mixed : MixedCheckboxStates.Unchecked;
}

function stateValueToAriaChecked(state) {
  return state === MixedCheckboxStates.Checked ? true : state === MixedCheckboxStates.Mixed ? "mixed" : false;
}

function stateValueToChecked(state) {
  return state === MixedCheckboxStates.Checked ? true : false;
} // TODO: Move to @reach/utils


function useControlledSwitchWarning(controlPropValue, controlPropName, componentName) {
  /*
   * Determine whether or not the component is controlled and warn the developer
   * if this changes unexpectedly.
   */
  var isControlled = controlPropValue != null;

  var _React$useRef = (0,react.useRef)(isControlled),
      wasControlled = _React$useRef.current;

  (0,react.useEffect)(function () {
    if (false) {}
  }, [componentName, controlPropName, isControlled, wasControlled]);
} ////////////////////////////////////////////////////////////////////////////////

function useRefDevWarning(ref, message) {
  if (false) { var messageRef; }
}

var _excluded$1 = (/* unused pure expression or super */ null && (["as", "checked", "children", "defaultChecked", "disabled", "onClick", "onChange", "__componentName"])),
    _excluded2 = (/* unused pure expression or super */ null && (["as", "onBlur", "onFocus"])),
    _excluded3 = (/* unused pure expression or super */ null && (["children", "id", "name", "value"]));
////////////////////////////////////////////////////////////////////////////////
var CustomCheckboxContext = /*#__PURE__*/(0,reach_utils_context_esm/* createNamedContext */.o)("CustomCheckboxContext", {});

function useCustomCheckboxContext() {
  return useContext(CustomCheckboxContext);
} ////////////////////////////////////////////////////////////////////////////////

/**
 * CustomCheckboxContainer
 *
 * Wrapper component and context provider for a custom checkbox.
 *
 * @see Docs https://reach.tech/checkbox#customcheckboxcontainer
 */


var CustomCheckboxContainer = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function CustomCheckboxContainer(_ref, forwardedRef) {
  var _ref$as = _ref.as,
      Comp = _ref$as === void 0 ? "span" : _ref$as,
      controlledChecked = _ref.checked,
      children = _ref.children,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      onChange = _ref.onChange,
      _ref$__componentName = _ref.__componentName,
      __componentName = _ref$__componentName === void 0 ? "CustomCheckboxContainer" : _ref$__componentName,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var inputRef = useRef(null);

  var _useMixedCheckbox = useMixedCheckbox(inputRef, {
    defaultChecked: defaultChecked,
    checked: controlledChecked,
    disabled: disabled,
    onChange: onChange
  }, __componentName),
      inputProps = _useMixedCheckbox[0],
      stateData = _useMixedCheckbox[1];

  var _React$useState = useState(false),
      focused = _React$useState[0],
      setFocused = _React$useState[1];

  function handleClick() {
    // Wait a frame so the input event is triggered, then focus the input
    window.requestAnimationFrame(function () {
      inputRef.current && inputRef.current.focus();
    });
  }

  var context = {
    defaultChecked: defaultChecked,
    disabled: disabled,
    focused: focused,
    inputProps: inputProps,
    inputRef: inputRef,
    setFocused: setFocused
  };
  useControlledSwitchWarning(controlledChecked, "checked", __componentName);
  useCheckStyles("checkbox");
  return /*#__PURE__*/createElement(CustomCheckboxContext.Provider, {
    value: context
  }, /*#__PURE__*/createElement(Comp, _extends({}, props, {
    ref: forwardedRef,
    "data-reach-custom-checkbox-container": "",
    "data-focused": focused ? "" : undefined,
    "data-state": checkedPropToStateValue(stateData.checked),
    onClick: composeEventHandlers(onClick, handleClick)
  }), isFunction(children) ? children({
    checked: inputProps["aria-checked"],
    inputRef: inputRef,
    focused: focused
  }) : children));
})));
/**
 * @see Docs https://reach.tech/checkbox#custom-checkboxcontainer-props
 */

if (false) {} ////////////////////////////////////////////////////////////////////////////////

/**
 * CustomCheckboxInput
 *
 * Component to render the HTML input element for our custom checkbox. The
 * rendered element should be visually hidden and exists only to manage its
 * state and hold a form name and value.
 *
 * @see Docs https://reach.tech/checkbox#customcheckboxinput
 */


var CustomCheckboxInput = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function CustomCheckboxInput(_ref2, forwardedRef) {
  var _ref2$as = _ref2.as,
      Comp = _ref2$as === void 0 ? "input" : _ref2$as,
      onBlur = _ref2.onBlur,
      onFocus = _ref2.onFocus,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  var _useCustomCheckboxCon = useCustomCheckboxContext(),
      focused = _useCustomCheckboxCon.focused,
      inputProps = _useCustomCheckboxCon.inputProps,
      inputRef = _useCustomCheckboxCon.inputRef,
      setFocused = _useCustomCheckboxCon.setFocused;

  var ref = useComposedRefs(forwardedRef, inputRef);
  var mounted = useRef(true);

  function handleBlur() {
    // window.requestAnimationFrame(() => send(CustomCheckboxEvents.Blur));
    window.requestAnimationFrame(function () {
      if (mounted.current) {
        setFocused(false);
      }
    });
  }

  function handleFocus() {
    // window.requestAnimationFrame(() => send(CustomCheckboxEvents.Focus));
    window.requestAnimationFrame(function () {
      if (mounted.current) {
        setFocused(true);
      }
    });
  }

  useEffect(function () {
    return function () {
      return void (mounted.current = false);
    };
  }, []);
  return /*#__PURE__*/createElement(Comp, _extends({}, props, inputProps, {
    ref: ref,
    type: "checkbox",
    "data-reach-custom-checkbox-input": "",
    "data-focused": focused ? "" : undefined,
    onBlur: composeEventHandlers(onBlur, handleBlur),
    onFocus: composeEventHandlers(onFocus, handleFocus)
  }));
})));

if (false) {} ////////////////////////////////////////////////////////////////////////////////

/**
 * CustomCheckbox
 *
 * A checkbox component with a wrapper element for custom styling.
 *
 * @see Docs https://reach.tech/checkbox#customcheckbox-1
 */


var CustomCheckbox = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function CustomCheckbox(_ref3, forwardedRef) {
  var children = _ref3.children,
      id = _ref3.id,
      name = _ref3.name,
      value = _ref3.value,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3);

  return /*#__PURE__*/createElement(CustomCheckboxContainer, _extends({}, props, {
    "data-reach-custom-checkbox": "" // @ts-ignore
    ,
    __componentName: "CustomCheckbox"
  }), /*#__PURE__*/createElement(CustomCheckboxInput, {
    id: id,
    name: name,
    ref: forwardedRef,
    value: value
  }), children);
})));
/**
 * @see Docs https://reach.tech/checkbox#custom-checkbox-props
 */

if (false) {} ////////////////////////////////////////////////////////////////////////////////



;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/checkbox/checkbox-checked.svg
/* harmony default export */ var checkbox_checked = ({"src":"/_next/static/media/checkbox-checked.7e7bd052.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/checkbox/checkbox-checked-disabled.svg
/* harmony default export */ var checkbox_checked_disabled = ({"src":"/_next/static/media/checkbox-checked-disabled.41da4ba4.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/checkbox/checkbox-mixed.svg
/* harmony default export */ var checkbox_mixed = ({"src":"/_next/static/media/checkbox-mixed.32242cb6.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/checkbox/checkbox-mixed-disabled.svg
/* harmony default export */ var checkbox_mixed_disabled = ({"src":"/_next/static/media/checkbox-mixed-disabled.2910ce2f.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/checkbox/index.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 16px;\n  display: block;\n  flex-shrink: 0;\n  appearance: none;\n  margin: 0;\n  background: white;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n  border: thin solid var(--coolGray-300);\n  border-radius: 4px;\n  outline: none;\n\n  &:disabled {\n    background-color: var(--coolGray-300);\n    border-color: var(--coolGray-300);\n\n    &:checked {\n      background-color: var(--coolGray-300);\n      background-image: url(",
        ");\n      border-color: var(--coolGray-300);\n    }\n\n    &[aria-checked='mixed'] {\n      background-color: var(--coolGray-300);\n      background-image: url(",
        ");\n      border-color: var(--coolGray-300);\n    }\n  }\n\n  &:enabled {\n    &:checked {\n      background-color: var(--blue-700);\n      background-image: url(",
        ");\n      border-color: var(--blue-700);\n      box-shadow: var(--shadow-base);\n    }\n\n    &[aria-checked='mixed'] {\n      background-color: var(--blue-700);\n      background-image: url(",
        ");\n      border-color: var(--blue-700);\n      box-shadow: var(--shadow-base);\n    }\n\n    &:hover,\n    &:focus {\n      border-color: var(--blue-400);\n    }\n\n    &:focus-visible {\n      border-color: var(--blue-400);\n      box-shadow: 0 0 0 2px var(--indigoOutlineColor);\n    }\n  }\n\n  &[data-invalid='true'] {\n    border-color: var(--pink-900);\n\n    &:hover {\n      border-color: var(--pink-900);\n    }\n\n    &:focus {\n      border-color: var(--pink-900);\n      box-shadow: 0 0 0 2px var(--pink-200);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Input = (0,styled_components_browser_esm/* default */.ZP)(MixedCheckbox).withConfig({
    componentId: "sc-e38e583a-0"
})(_templateObject(), checkbox_checked_disabled, checkbox_mixed_disabled, checkbox_checked, checkbox_mixed);

;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/checkbox/index.jsx







/**
 * Renders a checkbox. Supports checked, unchecked and mixed states.
 */ function Checkbox(_param) {
    var ariaLabel = _param.ariaLabel, checked = _param.checked, defaultChecked = _param.defaultChecked, id = _param.id, name = _param.name, onChange = _param.onChange, onInput = _param.onInput, onInvalid = _param.onInvalid, value = _param.value, _size = _param.size, size = _size === void 0 ? "regular" : _size, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "ariaLabel",
        "checked",
        "defaultChecked",
        "id",
        "name",
        "onChange",
        "onInput",
        "onInvalid",
        "value",
        "size"
    ]);
    var ref = (0,react.useState)(false), invalid = ref[0], setInvalid = ref[1];
    var props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        checked: checked,
        defaultChecked: defaultChecked,
        "aria-label": ariaLabel
    });
    if (onChange) {
        props.onChange = function(event) {
            var target = event.target;
            onChange(target.checked, event);
        };
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread/* default */.Z)({
        "data-invalid": invalid,
        id: id,
        name: name,
        onInvalid: function(event) {
            if (onInvalid) {
                onInvalid(event);
            }
            setInvalid(true);
        },
        onInput: function(event) {
            if (onInput) {
                onInput(event);
            }
            setInvalid(false);
        },
        size: size
    }, props));
};
Checkbox.propTypes = {
    /**
   * ARIA label.
   */ ariaLabel: (prop_types_default()).string,
    /**
   * Value. Use for controlled checkboxes along with `onChange`.
   */ checked: prop_types_default().oneOfType([
        (prop_types_default()).bool,
        prop_types_default().oneOf([
            "mixed"
        ])
    ]),
    /**
   * Default checked. Use for uncontrolled inputs.
   */ defaultChecked: prop_types_default().oneOfType([
        (prop_types_default()).bool,
        prop_types_default().oneOf([
            "mixed"
        ])
    ]),
    /**
   * Whether to disable the input.
   */ disabled: (prop_types_default()).bool,
    /**
   * Input ID. If not provided, ID will be automatically generated.
   */ id: (prop_types_default()).string,
    /**
   * Input name.
   */ name: (prop_types_default()).string.isRequired,
    /**
   * Function called on change. Will be called with two attributes: `checked` and `event`.
   */ onChange: (prop_types_default()).func,
    /**
   * Function called on input. Will be called with one attribute: `event`.
   */ onInput: (prop_types_default()).func,
    /**
   * Function called on invalid. Will be called with one attribute: `event`.
   */ onInvalid: (prop_types_default()).func,
    /**
   * Whether the input should be required.
   */ required: (prop_types_default()).bool,
    /**
   * Checkbox size.
   */ size: prop_types_default().oneOf([
        "regular",
        "small"
    ]),
    /**
   * Checkbox value.
   */ value: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/simple_field/index.styles.js

function index_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        "px;\n"
    ]);
    index_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin: 0;\n  color: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 3px;\n  font-size: 12px;\n  color: var(--coolGray-400);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  color: var(--coolGray-500);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 14px 12px;\n      background-color: var(--blue-50);\n      border-radius: 4px;\n\n      ",
        " {\n        margin: 0;\n      }\n\n      ",
        " {\n        margin-bottom: 0;\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  max-width: 400px;\n\n  ",
        "\n\n  &:focus-within {\n    ",
        " {\n      color: var(--blue-900);\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var shouldForwardProp = function(prop) {
    return ![].includes(prop);
};
var ElementAndLabelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ccd1f9a0-0"
})(index_styles_templateObject(), function(props) {
    return props.size === "small" ? 8 : 12;
});
var LabelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ccd1f9a0-1"
})(_templateObject1());
var Label = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-ccd1f9a0-2"
})(_templateObject2(), function(props) {
    if (props.disabled) {
        return "var(--coolGray-400) !important";
    }
    if (props.invalid) {
        return "var(--pink-900) !important";
    }
    return "var(--coolGray-700)";
}, function(props) {
    return props.size === "small" ? "14px" : "inherit";
});
var Required = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ccd1f9a0-3"
})(_templateObject3());
var Hint = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-ccd1f9a0-4"
})(_templateObject4());
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)("div").withConfig({
    shouldForwardProp: shouldForwardProp
}).withConfig({
    componentId: "sc-ccd1f9a0-5"
})(_templateObject6(), function(props) {
    return props.frame && (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), ElementAndLabelWrapper, Hint);
}, Label);

;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/simple_field/index.jsx




function SimpleField(param) {
    var children = param.children, className = param.className, disabled = param.disabled, frame = param.frame, hideRequired = param.hideRequired, hint = param.hint, id = param.id, label = param.label, required = param.required, size = param.size;
    var ref = (0,react.useState)(false), invalid = ref[0], setInvalid = ref[1];
    var child = react.Children.only(children);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: className,
        frame: frame,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ElementAndLabelWrapper, {
                size: size,
                children: [
                    /*#__PURE__*/ (0,react.cloneElement)(child, {
                        onInvalid: function(event) {
                            if (child.props.onInvalid) {
                                child.props.onInvalid(event);
                            }
                            setInvalid(true);
                        },
                        onInput: function(event) {
                            if (child.props.onInput) {
                                child.props.onInput(event);
                            }
                            setInvalid(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                disabled: disabled,
                                htmlFor: id,
                                invalid: invalid,
                                size: size,
                                children: label
                            }),
                            required && !hideRequired ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Required, {
                                children: "Required"
                            }) : null
                        ]
                    })
                ]
            }),
            hint ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Hint, {
                children: hint
            }) : null
        ]
    });
};
SimpleField.propTypes = {
    children: (prop_types_default()).node.isRequired,
    className: (prop_types_default()).string,
    disabled: (prop_types_default()).bool,
    frame: (prop_types_default()).bool,
    hideRequired: (prop_types_default()).bool,
    hint: (prop_types_default()).node,
    id: (prop_types_default()).string,
    label: (prop_types_default()).node,
    required: (prop_types_default()).bool,
    size: prop_types_default().oneOf([
        "regular",
        "small"
    ])
};

;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/checkbox_field/index.jsx







/**
 * Renders a checkbox field. Supports checked, unchecked and mixed states.
 */ function CheckboxField(_param) {
    var className = _param.className, frame = _param.frame, hideRequired = _param.hideRequired, hint = _param.hint, id = _param.id, label = _param.label, size = _param.size, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "frame",
        "hideRequired",
        "hint",
        "id",
        "label",
        "size"
    ]);
    var idWithDefault = (0,reach_auto_id_esm/* useId */.M)(id);
    var disabled = otherProps.disabled, required = otherProps.required;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleField, {
        className: className,
        disabled: disabled,
        frame: frame,
        hideRequired: hideRequired,
        hint: hint,
        id: idWithDefault,
        label: label,
        required: required,
        size: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, (0,_object_spread/* default */.Z)({
            id: idWithDefault
        }, otherProps))
    });
};
CheckboxField.propTypes = {
    /**
   * ARIA label.
   */ ariaLabel: (prop_types_default()).string,
    /**
   * Value. Use for controlled checkboxes along with `onChange`.
   */ checked: prop_types_default().oneOfType([
        (prop_types_default()).bool,
        prop_types_default().oneOf([
            "mixed"
        ])
    ]),
    /**
   * Field class name.
   */ className: (prop_types_default()).string,
    /**
   * Default checked. Use for uncontrolled inputs.
   */ defaultChecked: prop_types_default().oneOfType([
        (prop_types_default()).bool,
        prop_types_default().oneOf([
            "mixed"
        ])
    ]),
    /**
   * Whether to disable the input.
   */ disabled: (prop_types_default()).bool,
    /**
   * Whether to render the field as a frame.
   */ frame: (prop_types_default()).bool,
    /**
   * Whether to hide "Required" label despite field being required.
   */ hideRequired: (prop_types_default()).bool,
    /**
   * Input hint. Displayed below the input.
   */ hint: (prop_types_default()).node,
    /**
   * Input ID. If not provided, ID will be automatically generated.
   */ id: (prop_types_default()).string,
    /**
   * Input label. Displayed above the input.
   */ label: (prop_types_default()).node,
    /**
   * Input name.
   */ name: (prop_types_default()).string.isRequired,
    /**
   * Function called on change. Will be called with two attributes: `checked` and `event`.
   */ onChange: (prop_types_default()).func,
    /**
   * Whether the input should be required.
   */ required: (prop_types_default()).bool,
    /**
   * Checkbox size.
   */ size: prop_types_default().oneOf([
        "regular",
        "small"
    ]),
    /**
   * Checkbox value.
   */ value: (prop_types_default()).string
};


/***/ })

}]);